<template>
  <div>
    <div style="margin:auto;width: 900px;">
      <div style="height: 160px;font-size:38px;margin-top: 60px">
        <div style="margin-left:260px">
          <div >
            <span style="border-left: 5px solid #0060be;font-size: 28px;margin-right: 8px;height: 50px"></span>
            <span>联系我们</span>
          </div>
          <div style="font-size: 23px;margin-left:26px">Contact Us</div>
        </div>
      </div>
      <div>
        <div>
          <div  style="display:flex;font-weight: bold;color: #0060b2;align-items: center"><i v-html="websiteIcon"></i><span style="margin-left: 10px">官网</span></div>
          <div style="display:flex;">
            <div class="contactItem">凌恩生物官网：<a href="www.biozeron.com">www.biozeron.com</a></div>
            <div class="contactItem">凌波微课（云平台）官网：<a
                href="http://www.biomicroclass.com">http://www.biomicroclass.com</a></div>
          </div>
        </div>
        <div style="margin-top: 45px">
          <div style="display:flex;font-weight: bold;color: #0060b2;align-items: center"><i v-html="phoneIcon"></i><span style="margin-left: 10px">工作日-联系电话</span></div>
          <div style="display:flex;">
            <div class="contactItem">项目交付中心（南京）：130 3213 7176</div>
            <div class="contactItem">项目交付中心（上海）：186 1625 9916</div>
          </div>
        </div>
        <div style="margin-top: 45px">
          <div style="display:flex;font-weight: bold;color: #0060b2;align-items: center"><i v-html="serveIcon"></i><span style="margin-left: 10px"> 数据库和服务器平台搭建服务</span></div>
          <div style="display:flex;">
            <div class="contactItem">网址：<a href="http://vgsoft.biozeron.com/">http://vgsoft.biozeron.com</a></div>
          </div>
        </div>
      </div>
    </div>



  </div>
</template>

<script>
import {phoneIcon, serveIcon, websiteIcon} from "@/utils/iconUtils";

export default {
  name: "Contact",
  data() {
    return {
      phoneIcon: phoneIcon,
      websiteIcon: websiteIcon,
      serveIcon: serveIcon
    }
  }
}
</script>

<style scoped>
.contactItem {
  width: 50%;
  line-height: 43px;
  /*margin-left: 50px;*/
  height: 43px;
}
</style>
